import { gql } from '__generated__'

export const GetRosterSearches = gql(/* GraphQL */ `
    query GetRosterSearches(
        $rosterStatuses: [RosterStatus!]!
        $page: Int
        $limit: Int
    ) {
        rosterSearches(
            rosterStatuses: $rosterStatuses
            page: $page
            limit: $limit
        ) {
            data {
                id
                rosterName
                rosterType
                status
                createdAt
                startDateLabel
                placements {
                    placementCount
                    title {
                        value
                        id
                    }
                }
                companyOffices {
                    companyOffice {
                        officeLocation {
                            id
                            value
                        }
                    }
                }
                company {
                    id
                    value
                }
                industries {
                    industry {
                        id
                        value
                    }
                }
                sectors {
                    sector {
                        id
                        value
                    }
                }
                createdByUser {
                    preferredName
                }
                sharedRecruiters {
                    recruiter {
                        id
                        user {
                            profileImageKey
                            preferredName
                        }
                    }
                }
                candidateProcessStatusGroupSummary {
                    statusSummaryGroup {
                        summaryGroup
                        label
                    }
                    count
                }
                sharedClients {
                    clientId
                    client {
                        id
                        user {
                            preferredName
                            profileImageKey
                        }
                    }
                }
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetRosterMappings = gql(/* GraphQL */ `
    query GetRosterMappings(
        $rosterStatuses: [RosterStatus!]!
        $page: Int
        $limit: Int
    ) {
        rosterMappings(
            rosterStatuses: $rosterStatuses
            page: $page
            limit: $limit
        ) {
            data {
                id
                rosterName
                rosterType
                mapping {
                    id
                    isActive
                    createdAt
                    updatedAt
                    createdByUser {
                        id
                        preferredName
                    }
                    updatedByUser {
                        id
                        preferredName
                    }
                }
                status
                createdAt
                startDateLabel
                placements {
                    placementCount
                    title {
                        value
                        id
                    }
                }
                companyOffices {
                    companyOffice {
                        officeLocation {
                            id
                            value
                        }
                    }
                }
                company {
                    id
                    value
                }
                industries {
                    industry {
                        id
                        value
                    }
                }
                sectors {
                    sector {
                        id
                        value
                    }
                }
                createdByUser {
                    preferredName
                }
                sharedRecruiters {
                    recruiter {
                        id
                        user {
                            profileImageKey
                            preferredName
                        }
                    }
                }
                candidateProcessStatusGroupSummary {
                    statusSummaryGroup {
                        summaryGroup
                        label
                    }
                    count
                }
                sharedClients {
                    clientId
                    client {
                        id
                        user {
                            preferredName
                            profileImageKey
                        }
                    }
                }
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetRosterForClient = gql(/* GraphQL */ `
    query GetRosterForClient($rosterId: ID!) {
        getRosterForClient(rosterId: $rosterId) {
            id
            rosterType
            mapping {
                id
                filter
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
            rosterName
            status
            createdAt
            startDateLabel
            placements {
                placementCount
                title {
                    value
                    id
                }
            }
            companyOffices {
                companyOffice {
                    officeLocation {
                        id
                        value
                    }
                }
            }
            company {
                id
                value
            }
            industries {
                industry {
                    id
                    value
                }
            }
            sectors {
                sector {
                    id
                    value
                }
            }
            createdByUser {
                preferredName
            }
            sharedRecruiters {
                recruiter {
                    id
                    user {
                        profileImageKey
                        preferredName
                    }
                }
            }
            candidateProcessStatusGroupSummary {
                statusSummaryGroup {
                    summaryGroup
                    label
                }
                count
            }
            sharedClients {
                clientId
                client {
                    id
                    user {
                        preferredName
                        profileImageKey
                    }
                }
            }
        }
    }
`)

export const GetRosterSearchCandidateList = gql(/* GraphQL */ `
    query GetRosterCandidatesBySummaryGroup(
        $rosterId: ID!
        $summaryGroup: ProcessStatusGroup!
        $page: Int
        $limit: Int
    ) {
        getRosterCandidatesBySummaryGroup(
            rosterId: $rosterId
            summaryGroup: $summaryGroup
            page: $page
            limit: $limit
        ) {
            data {
                id
                candidate {
                    id
                    internalProfileImageKey
                    user {
                        id
                        nickname
                        firstName
                        preferredName
                        lastName
                        profileImageKey
                    }
                    currentWorkExperience {
                        companyOffice {
                            officeLocation {
                                id
                                value
                            }
                        }
                        company {
                            id
                            value
                        }
                        title {
                            id
                            value
                        }
                        industries {
                            industry {
                                id
                                value
                            }
                        }
                        sectors {
                            sector {
                                id
                                value
                            }
                        }
                    }
                    workExperience {
                        company {
                            id
                            value
                        }
                        isCurrent
                        endDate
                    }
                    education {
                        id
                        college {
                            id
                            value
                        }
                        graduationDate
                    }
                }
                clientFavorites {
                    clientId
                    updatedAt
                    createdAt
                }
                candidateProcessStatus {
                    processStatus {
                        id
                        status
                        statusLabel
                        processStatusSummaryGroup {
                            summaryGroup
                            label
                        }
                    }
                }
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetRosterCandidateStatusGroupCounts = gql(/* GraphQL */ `
    query GetRosterCandidateStatusGroupCounts(
        $rosterId: ID!
        $summaryGroups: [ProcessStatusGroup!]!
    ) {
        getRosterCandidateStatusGroupCounts(
            rosterId: $rosterId
            summaryGroups: $summaryGroups
        ) {
            statusSummaryGroup {
                summaryGroup
                label
            }
            count
        }
    }
`)

export const GetOtherSearchesForCandidate = gql(/* GraphQL */ `
    query GetOtherSearchesForCandidate($candidateId: ID!) {
        getCandidateInOtherSearchesForClient(candidateId: $candidateId) {
            id
            roster {
                rosterName
                id
            }
            candidateProcessStatus {
                processStatus {
                    status
                    statusLabel
                    processStatusSummaryGroup {
                        summaryGroup
                        label
                    }
                }
            }
            candidateProcessStatusHistory {
                processStatus {
                    status
                    statusLabel
                }
                isActive
                createdAt
                createdByUser {
                    preferredName
                    roles
                }
            }
        }
    }
`)

export const GetCandidatesForMapping = gql(/* GraphQL */ `
    query GetCandidatesForMapping($rosterId: ID!, $page: Int, $limit: Int) {
        getCandidatesForMapping(
            rosterId: $rosterId
            page: $page
            limit: $limit
        ) {
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
            data {
                id
                internalProfileImageKey
                recruitingStatus
                rosterCount
                currentLocation
                email
                firstName
                lastName
                nickname
                profileImageKey
                currentIndustry
                currentSector
                currentCompany
                currentTitle
            }
        }
    }
`)
